import ObjectModal from '@Components/modals/ObjectModal'
import Drilldown from 'components/drilldown/Layout'
import { formatters } from 'components/hierarchical-report/utils'
import pingCheckStore from 'modules/report/stores/pingCheck'

export default class PingCheckDrilldown extends Drilldown {
  store = pingCheckStore
  collection = 'Ping Check'
  report = 'ping-check'
  ignoreCustomFields = true

  metrics = {
    pingSuccess: { label: 'Success', field: 'success', value: true },
    pingFail: { label: 'Fail', field: 'success', value: false },
    show: { label: 'Show', field: 'show', value: true },
    total: { label: 'Total' },
  }

  fields = {
    default: ['success', 'show', 'email', 'phone', 'latency', 'feedbackMessage', 'requestDate'],
    options: [
      { group: 'General', value: "success", label: "Success" },
      { group: 'General', value: "show", label: "Show" },
      { group: 'General', value: "feedbackMessage", label: "Feedback Message" },
      { group: 'General', value: "latency", label: "Latency" },
      { group: 'General', value: "requestDate", label: "Request Date" },
      { group: 'General', value: "lastRegistration", label: "Last Registration" },
      { group: 'General', value: "queryParams", label: "Query Params" },

      { group: 'Traffic', value: 'allocationId', label: 'Allocation Id' },
      { group: 'Traffic', value: 'publisherId', label: 'Publisher Id' },

      { group: 'User', value: 'email', label: 'Email' },
      { group: 'User', value: 'phone', label: 'Phone' },
    ],
    fieldsFormatters: {
      email: cell => formatters.openNewTab("/reports/audit", { key: "email", value: cell }),
      phone: cell => formatters.openNewTab("/reports/audit", { key: "phone", value: cell }),
      queryParams: objectModalFormatter('queryParams', "Query Params"),
      latency: cell => formatters.seconds(cell),
    },
  }
}

const objectModalFormatter = (id, title, label = 'details') => (cell, _, idx) => {
  if (!cell) return null;

  if (typeof cell === 'string') {
    try {
      cell = JSON.parse(cell)
    } catch (error) {
      return cell
    }
  }
  const data = Object.entries(cell);
  return <ObjectModal data={data} title={title} labelButton={label} id={`${id}-${idx}`} />
}
